import { create } from 'zustand';

const initPlayerStore = Object.freeze({
  isFullScreen: false as boolean,
  showPlayerBar: false as boolean,
  disabledPlayerBar: false as boolean,
});

type PlayerStore = typeof initPlayerStore;

export const usePlayerStore = create<PlayerStore>((set) => ({
  ...initPlayerStore,
}));
